import get from 'lodash/get';
import { LEGACY_URLS, URLS, PATHS } from 'config';
import * as help from 'helpers';
import { commonStore } from 'stores';
import { API_ROOT } from 'agents';

export function route_secure_payment(data, request) {
    return new Promise(() => {
        let form = document.createElement('form');
        let req = document.createElement('input');
        let md = document.createElement('input');
        let termUrl = document.createElement('input');
        let redirect =
            request.url.indexOf('gift/purchase') >= 0
                ? '/payment/gift/secure_payment'
                : '/payment/securepayment';
        let reqData = request._data;
        let params = {
            plan: reqData.plan || reqData.plan_id,
            source: reqData.source,
            instrument: reqData.instrument,
        };

        if (reqData.free_trial || reqData.freetrial) {
            params.freeTrial = reqData.free_trial || reqData.freetrial;
        }

        if (reqData.callbackUrl) {
            params.callbackUrl = reqData.callbackUrl;
        }

        let term = `${API_ROOT}${redirect}?${help.str_serialize(params)}`;

        form.method = 'POST';
        form.action = data.issuerUrl;

        req.value = data.paRequest;
        req.name = 'PaReq';
        req.type = 'hidden';
        form.appendChild(req);

        md.value = data.md;
        md.name = 'MD';
        md.type = 'hidden';
        form.appendChild(md);

        termUrl.value = term;
        termUrl.name = 'TermUrl';
        termUrl.type = 'hidden';
        form.appendChild(termUrl);

        document.body.appendChild(form);

        form.submit();
    });
}

export function goto(where, params) {
    if (params) {
        const query = help.useQueryParams();
        where = `${where}?${help.str_serialize({ ...query, ...params })}`;
    }

    commonStore.routeHistory.push(where);
}

export function route_with_params(where, params = {}) {
    const query = help.useQueryParams();
    const args = help.str_serialize({ ...query, ...params });
    const queryParams = where.indexOf('?') < 0 && args ? `?${args}` : '';
    return `${where}${queryParams}`;
}

export function route_with_intent(route, search) {
    let params = '';
    if (search.continue) {
        params = `?continue=${encodeURIComponent(search.continue)}`;
    }
    return `${route}${params}`;
}

export function route_continue_with_params() {
    const query = help.useQueryParams();
    let destination = '';
    if (query.continue) {
        destination += query.continue;
        const { continue: string, ...extraArgs } = query;
        destination += `?${help.str_serialize(extraArgs)}`;
    }
    return destination;
}

export function is_gift_page() {
    return get(commonStore, 'routeLocation.pathname', '').includes('gift');
}

export function is_gift_checkout_page() {
    return (
        get(commonStore, 'routeLocation.pathname', '').search(
            /gift\/checkout/,
        ) > -1
    );
}

// turn /black-friday/checkout?blah to /black-friday
export const prepareOriginalPath = () => {
    const { coupon } = help.useQueryParams();
    const params = coupon ? '?coupon=' + coupon : '';
    return '/' + window.location.pathname.split('/')[1] + params;
};

export function redirect_legacy_tokens(token) {
    let go = '/';

    if (LEGACY_URLS[token.url]) {
        go = LEGACY_URLS[token.url];

        if (token.data) {
            go = `${go}?${help.str_serialize(token.data)}`;
        }
    }

    return go;
}

// For redirections to other domains than account.yousician.com we don't have to involve react router
// Redirecting straight out of javascript is faster and avoids errors
export const handleExternalRedirects = () => {
    const { pathname, hash } = window.location || {};
    if (
        pathname === PATHS.privacyNotice ||
        hash.includes(PATHS.privacyNotice)
    ) {
        window.location.href = URLS.privacyNotice;
    }
};
